import React from 'react'

const WhatsappButton = () => {
  return (
       <a href="https://wa.me/+919789097806" target="_blank" rel="noreferrer" className=''>
            <div className="btn-whatsapp-pulse btn-whatsapp-pulse-border relative">
                <img className="absolute z-20 p-1 md:p-0" width={90} src='/images/icons/whatsapp.png' alt='whatsapp icon'/>
            </div>
        </a>
  )
}

export default WhatsappButton
